import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Setting } from '../models/setting.model';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

   public data: Subject<Setting> = new Subject<Setting>();
 
   public set(data:any){
     this.data.next(data as Setting);
   }

}
